function NavbarTopMenu({ children }) {
  return (
    <div className="navbar-top-menu">
      {children}
    </div>
  );
}

export default NavbarTopMenu;
